import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LOCATIONS } from '@modules/edit-preference/components/privacy-password/privacy-setting-messages.enum';
import { NEW_POST_CONST } from '@modules/dashboard/components/new-post/newposts/constants';
import { NEW_POST_MESSAGES } from '@modules/dashboard/constants/home-strings.constant';

export interface watermarkChangeProps {
  watermark: boolean;
  watermarkSettings: any
}

@Component({
  selector: 'app-watermark-controls',
  templateUrl: './watermark-controls.component.html',
  styleUrls: ['./watermark-controls.component.scss']
})
export class WatermarkControlsComponent implements OnInit {
  @Input() isVideo: boolean = false;
  @Input() watermarkLabel: string = '';
  @Input() locationOptions: any;
  @Input() watermark: boolean;
  @Input() globalWatermark: any;
  @Input() hint: string = '';
  @Output() watermarkChange = new EventEmitter<watermarkChangeProps>();
  @Output() globalWatermarkChange = new EventEmitter<any>();

  NEW_POST_CONST = NEW_POST_CONST;
  newPostMessage = NEW_POST_MESSAGES;
  LOCATIONS = LOCATIONS;

  constructor() { }

  ngOnInit(): void {
  }

  onToggleWatermark(event: any) {
    this.watermark = event.target.checked;
    this.watermarkChange.emit({
      watermark: this.watermark,
      watermarkSettings: this.globalWatermark
    });
  }

  onChangeWatermarkColor(color: string): void {
    this.globalWatermark.color = color;
    this.applyGlobalWatermark();
  }

  applyGlobalWatermark() {
    this.globalWatermarkChange.emit(this.globalWatermark);
  }
}
